export type BlogPost = {
  slug: string;
  publishedAt: string;
  title: string;
  metaDescription: string;
  keywords: string[];
  /** Markdown body (no H1; listing metadata holds title). */
  body: string;
};

/** Parses `content/blog/source.md` (CRSHM export with ## N. sections). */
export function parseBlogMarkdownSource(raw: string): BlogPost[] {
  raw = raw.replace(/\r\n/g, "\n");
  const start = raw.search(/^## 1\.\s/m);
  if (start === -1) return [];

  const rest = raw.slice(start);
  const chunks = rest.split(/\n---\n\n(?=## \d+\.\s)/);
  const posts: BlogPost[] = [];

  for (const chunk of chunks) {
    const trimmed = chunk.trim();
    if (!/^## \d+\./m.test(trimmed)) continue;

    const titleMatch = trimmed.match(/^## \d+\.\s*(.+)$/m);
    const dateMatch = trimmed.match(/\*\*Publish date:\*\*\s*(\d{4}-\d{2}-\d{2})/);
    const slugMatch = trimmed.match(/\*\*Slug:\*\*\s*`([^`]+)`/);
    const kwMatch = trimmed.match(/\*\*SEO keywords:\*\*\s*(.+)$/m);
    const metaMatch = trimmed.match(/\*\*Meta description:\*\*\s*(.+)$/m);

    if (!titleMatch || !dateMatch || !slugMatch || !kwMatch || !metaMatch) continue;

    const metaEnd = metaMatch.index! + metaMatch[0].length;
    const body = trimmed.slice(metaEnd).trim();

    posts.push({
      slug: slugMatch[1].trim(),
      publishedAt: dateMatch[1],
      title: titleMatch[1].trim(),
      metaDescription: metaMatch[1].trim(),
      keywords: kwMatch[1]
        .split(",")
        .map((k) => k.trim())
        .filter(Boolean),
      body,
    });
  }

  return posts;
}
